import React, { useMemo, useState } from 'react';
import { useGetDashboardAllPermissions, useGetAllOrganisations } from '../../apis';
import CreateForm from './CreateForm';
import PreviousAnnouncements from './PreviousAnnouncements';
import { useGetAnnouncements } from './apis';
import { Modal } from '../../../../UiKit';
import UpdateForm from './UpdateForm';

const Announcements = () => {
  const dashboard = 'lifeline_dashboard';
  const limitToFetchAnnouncements = 5;
  const [idPermissionMap, setIdPermissionMap] = useState();
  const [idOrganisationMap, setIdOrganisationMap] = useState();
  const [offset, setOffset] = useState(0);
  const [updateAnnouncementDetails, setUpdateAnnouncementDetails] = useState();
  const [updateStateDetails, setUpdateStateDetails] = useState();
  const { data: dashboardPermissions, isLoading: permissionsLoading } =
    useGetDashboardAllPermissions(dashboard, {
      onSuccess: (result) => {
        const len = result.permissions.length;
        let permissionsMap = {};
        for (let i = 0; i < len; i++) {
          const id = result.permissions[i].id;
          const permissionName = result.permissions[i].name;
          permissionsMap = { ...permissionsMap, [id]: permissionName };
        }
        setIdPermissionMap(permissionsMap);
      },
    });

  const { data: organisations, isLoading: organisationsLoading } =
    useGetAllOrganisations({
      onSuccess: (result) => {
        const len = result.organisations.length;
        let organisationsMap = {};
        for (let i = 0; i < len; i++) {
          const id = result.organisations[i].id;
          const organisationName = result.organisations[i].name;
          organisationsMap = { ...organisationsMap, [id]: organisationName };
        }
        setIdOrganisationMap(organisationsMap);
      },
    });

  const getPermissionsList = useMemo(() => {
    if (!dashboardPermissions) return [];
    return dashboardPermissions.permissions.map(({ name, id }) => ({
      name: name,
      id: id,
    }));
  }, [dashboardPermissions]);

  const getOrganisationsList = useMemo(() => {
    if (!organisations) return [];
    return organisations.organisations.map(({ name, id }) => ({
      name: name,
      id: id,
    }));
  }, [organisations])

  const {
    data: previousAnnouncements,
    isLoading: isAnnouncementsLoading,
    refetch: refetchAnnouncements,
  } = useGetAnnouncements({}, offset, limitToFetchAnnouncements);

  const closeUpdateFormPopUp = () => {
    setUpdateAnnouncementDetails(null);
  };

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-gap-8'>
      <CreateForm
        getPermissionsList={getPermissionsList}
        permissionsLoading={permissionsLoading}
        getOrganisationsList={getOrganisationsList}
        organisationsLoading={organisationsLoading}
        refetchAnnouncements={refetchAnnouncements}
      />
      <PreviousAnnouncements
        offset={offset}
        previousAnnouncements={previousAnnouncements}
        isAnnouncementsLoading={isAnnouncementsLoading}
        refetchAnnouncements={refetchAnnouncements}
        idPermissionMap={idPermissionMap}
        idOrganisationMap={idOrganisationMap}
        setOffset={setOffset}
        setUpdateAnnouncementDetails={setUpdateAnnouncementDetails}
        setUpdateStateDetails={setUpdateStateDetails}
      />
      {updateAnnouncementDetails ? (
        <div>
          <Modal
            isVisible={updateAnnouncementDetails?.id}
            type='medium'
            padding={0}
            paddingTop={'1rem'}
            maxHeight='60vh'
            containerStyles={{ margin: '16px 0 20px 0', padding: '0 20px' }}
            titleComponent={
              <span className='tw-text-600 tw-font-semibold tw-text-green-700'>
                Update Announcement
              </span>
            }
            handleClose={closeUpdateFormPopUp}
            component={
              <UpdateForm
                getPermissionsList={getPermissionsList}
                permissionsLoading={permissionsLoading}
                getOrganisationsList={getOrganisationsList}
                organisationsLoading={organisationsLoading}
                idPermissionMap={idPermissionMap}
                idOrganisationMap={idOrganisationMap}
                defaultValues={updateAnnouncementDetails}
                refetchAnnouncements={refetchAnnouncements}
                closeUpdateFormPopUp={closeUpdateFormPopUp}
                updateStateDetails={updateStateDetails}
              />
            }
          />
        </div>
      ) : null}
    </div>
  );
};

export default Announcements;
